module.exports = __webpack_public_path__ + "img/progress_7.ac4b6599.png";